import topLine from '../../../../../static/images/hp/hero-overlay/topLine.svg';
import bottomLeft from '../../../../../static/images/hp/hero-overlay/bottomLeft.svg';
import bottomRight from '../../../../../static/images/hp/hero-overlay/bottomRight.svg';

export const container = () => ({
    position: 'absolute',
    height: '90%',
    width: '100%',
    zIndex: 1,
    backgroundImage: `url(${topLine}), url(${bottomLeft}), url(${bottomRight})`,
    backgroundPosition: 'top 10% center, bottom left 10%, bottom 10% right 20%',
    backgroundRepeat: 'no-repeat',
    tablet: {
        backgroundPosition: 'top 10% center, bottom left 10%, bottom 10% right 20%',
    },
    tabletLarge: {
        backgroundPosition: 'top 10% center, bottom 7% left 10%, bottom 15% right 20%',
    },
    desktop1200: {
        backgroundPosition: 'top 20% center, bottom 7% left 10%, bottom 15% right 20%',
    },
});
